@let theme = partyGameSplashScreenOverlayService.theme();
@if (partyGameSplashScreenOverlayService.isVisible() && theme) {
    <div
        class="pointer-events-auto fixed inset-0 z-[50000]"
        animate.enter="dc-anim-fade-in"
        animate.leave="dc-anim-fade-out"
        [style.--dc-anim-enter-duration.ms]="160"
        [style.--dc-anim-leave-duration.ms]="220">
        <app-party-game-splash-screen
            [title]="partyGameSplashScreenOverlayService.title()"
            [theme]="theme"
            [badgeIcon]="partyGameSplashScreenOverlayService.badgeIcon()"></app-party-game-splash-screen>
    </div>
}
